export const isPositiveInteger = (value: number) => Number.isInteger(value) && value > 0;
